import { Cpu, Award, ShieldCheck, Globe } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { ADVANTAGE_ICONS, ADVANTAGE_SPANS, IMAGES } from "./data";

const ICONS = { Cpu, Award, ShieldCheck, Globe };

export const Advantage = () => {
  const { t } = useLanguage();
  return (
    <section id="advantage" data-testid="advantage-section"
      className="relative overflow-hidden bg-navy-deep py-24 lg:py-32">
      <img src={IMAGES.skyline} alt="" aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.07]" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy-deep via-navy-deep/85 to-navy-deep" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>{t.advantage.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-slate-50 sm:text-4xl lg:text-5xl">
              {t.advantage.titleA} <span className="italic text-gold-gradient">{t.advantage.titleB}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 leading-relaxed text-slate-400">{t.advantage.body}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-12">
          {t.advantage.items.map((a, i) => {
            const Icon = ICONS[ADVANTAGE_ICONS[i]];
            return (
              <Reveal key={a.title} delay={i * 0.08} className={`md:col-span-1 ${ADVANTAGE_SPANS[i]}`}>
                <div data-testid={`advantage-card-${i}`}
                  className="group relative h-full overflow-hidden border border-navy-border bg-navy-card/70 p-8 backdrop-blur-sm transition-colors duration-500 hover:border-gold/50 lg:p-10">
                  <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-gold/5 blur-2xl transition-opacity duration-500 group-hover:bg-gold/10" />
                  <div className="flex items-start justify-between gap-6">
                    <Icon className="h-8 w-8 text-gold" strokeWidth={1.1} />
                    <span className="border border-gold/30 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold/90">
                      {a.badge}
                    </span>
                  </div>
                  <h3 className="mt-8 font-serif text-2xl font-medium text-slate-100">{a.title}</h3>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-400">{a.desc}</p>
                  <div className="mt-8 h-px w-full bg-navy-border transition-colors duration-500 group-hover:bg-gold/30" />
                  <span className="mt-4 block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                    {t.advantage.guarantee} {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
